import React, { useEffect, useState } from 'react'
import {
  Button,
  Form as BForm,
  Row,
  Col,
  Modal,
  Spinner
} from '@themesberg/react-bootstrap'
import { Formik, Form, ErrorMessage } from 'formik'
import { editproviderSchema, providerSchema } from '../schema'
import Preloader from '../../../../components/Preloader'
import Trigger from '../../../../components/OverlayTrigger'
import { isTenant } from '../../../../utils/constants'
import CreatableSelect from '../../../../components/CreatableSelect'
import { TAG_OPTIONS } from '../../../../constants/provider'

const CreateCasinoProviders = ({
  handleClose,
  data,
  show,
  type,
  loading,
  aggregators,
  createProvider,
  updateProvider,
  isHidden
}) => {
  const [allowedOptions, setAllowedOptions] = useState([])
  const [selectedAllowed, setSelectedAllowed] = useState()
  const [restrictedOptions, setRestrictedOptions] = useState([])
  const [selectedRestricted, setSelectedRestricted] = useState()

  useEffect(() => {
    if (data?.allowedFeeGroups?.length > 0) {
      const options = []
      for (const g of data.allowedFeeGroups) {
        if (g !== '' && g !== null) {
          options.push({ label: g, value: g })
        }
      }
      setSelectedAllowed(options)
      setAllowedOptions(options)
    } else {
      setSelectedAllowed([])
      setAllowedOptions([])
    }
    if (data?.restrictedFeeGroups?.length > 0) {
      const options = []
      for (const g of data.restrictedFeeGroups) {
        if (g !== '' && g !== null) {
          options.push({ label: g, value: g })
        }
      }
      setSelectedRestricted(options)
      setRestrictedOptions(options)
    } else {
      setSelectedRestricted([])
      setRestrictedOptions([])
    }
  }, [data])

  return (
    <>
      {loading
        ? (
          <Preloader />
          )
        : (
          <Formik
            enableReinitialize
            initialValues={
              data?.masterCasinoProviderId
                ? {
                    name: data.name,
                    tag: data.tag || TAG_OPTIONS.universal.name,
                    isActive: data.isActive,
                    thumbnail: null,
                    masterGameAggregatorId: data?.masterGameAggregatorId,
                    demo: data.demo,
                    allowedFeeGroups: selectedAllowed,
                    restrictedFeeGroups: selectedRestricted
                  }
                : {
                    name: '',
                    tag: !isHidden({ module: { key: 'CasinoProviderTag', value: 'U' } }) ? '' : TAG_OPTIONS.universal.name,
                    isActive: false,
                    masterGameAggregatorId: '',
                    thumbnail: '',
                    demo: false,
                    allowedFeeGroups: [],
                    restrictedFeeGroups: []
                  }
                }
            validationSchema={
              data?.masterCasinoProviderId ? editproviderSchema : providerSchema
            }
            onSubmit={(formValues) => {
              formValues = {
                ...formValues,
                allowedFeeGroups: formValues?.allowedFeeGroups?.length ? formValues?.allowedFeeGroups?.map(opt => opt?.value) : [],
                restrictedFeeGroups: formValues?.restrictedFeeGroups?.length ? formValues?.restrictedFeeGroups?.map(opt => opt?.value) : []
              }
              data?.masterCasinoProviderId
                ? updateProvider(formValues,
                  isTenant
                    ? { tenantCasinoProviderId: data?.tenantCasinoProviderId }
                    : { masterCasinoProviderId: data?.masterCasinoProviderId })
                : createProvider(formValues)

              handleClose()
            }}
          >
            {({
              values,
              handleChange,
              handleSubmit,
              handleBlur,
              setFieldValue
            }) => (
              <Form>
                <Modal
                  show={show}
                  onHide={handleClose}
                  backdrop='static'
                  keyboard={false}
                >
                  <Modal.Header closeButton>
                    <Modal.Title>{type} Provider</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Row className='mt-3'>
                      <Col>
                        <BForm.Label>
                          Provider Name<span className='text-danger'> *</span>
                        </BForm.Label>

                        <BForm.Control
                          type='text'
                          name='name'
                          placeholder='Enter Provider Name'
                          value={values.name}
                          onBlur={handleBlur}
                          disabled={isTenant}
                          onChange={handleChange}
                        />

                        <ErrorMessage
                          component='div'
                          name='name'
                          className='text-danger'
                        />
                      </Col>
                    </Row>

                    {!isTenant &&
                      <Row className='mt-3'>
                        <Col>
                          <BForm.Label>
                            Aggregator<span className='text-danger'> *</span>
                          </BForm.Label>

                          <BForm.Select
                            type='text'
                            name='masterGameAggregatorId'
                            value={values.masterGameAggregatorId}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            disabled={data?.masterCasinoProviderId}
                          >
                            <option value='' disabled>
                              ---Select Aggregator---
                            </option>
                            {aggregators &&
                              aggregators?.rows.map(
                                ({ masterGameAggregatorId, name }) => {
                                  return (
                                    <option
                                      value={masterGameAggregatorId}
                                      key={masterGameAggregatorId}
                                    >
                                      {name}
                                    </option>
                                  )
                                }
                              )}
                          </BForm.Select>

                          <ErrorMessage
                            component='div'
                            name='masterGameAggregatorId'
                            className='text-danger'
                          />
                        </Col>
                      </Row>}

                    <Row className='mt-3'>
                      <Col className='d-flex'>
                        <BForm.Label>
                          Status<span className='text-danger'> *</span>
                        </BForm.Label>

                        <BForm.Check
                          className='mx-auto'
                          type='checkbox'
                          name='isActive'
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.isActive}
                          checked={values.isActive}
                          defaultChecked={values.isActive}
                        />
                      </Col>
                    </Row>

                    <Row className='mt-3'>
                      <Col className='d-flex'>
                        <BForm.Label>
                          Demo Mode<span className='text-danger'> *</span>
                        </BForm.Label>

                        <BForm.Check
                          className='mx-auto'
                          type='checkbox'
                          name='demo'
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.demo}
                          checked={values.demo}
                          defaultChecked={values.demo}
                        />
                      </Col>
                    </Row>

                    <Row className='mt-3'>
                      <Col>
                        <BForm.Label>Allowed Fee Groups</BForm.Label>

                        <CreatableSelect
                          options={allowedOptions}
                          fieldName='allowedFeeGroups'
                          setOptions={setAllowedOptions}
                          setFieldValue={setFieldValue}
                          selectedOption={selectedAllowed}
                          setSelectedOption={setSelectedAllowed}
                        />
                      </Col>
                    </Row>

                    <Row className='mt-3'>
                      <Col>
                        <BForm.Label>Restricted Fee Groups</BForm.Label>

                        <CreatableSelect
                          options={restrictedOptions}
                          fieldName='restrictedFeeGroups'
                          setOptions={setRestrictedOptions}
                          setFieldValue={setFieldValue}
                          selectedOption={selectedRestricted}
                          setSelectedOption={setSelectedRestricted}
                        />
                      </Col>
                    </Row>

                    {!isHidden({ module: { key: 'CasinoProviderTag', value: 'U' } }) && (
                      <Row className='mt-3'>
                        <Col>
                          <BForm.Label>
                            Tags<span className='text-danger'> *</span>
                          </BForm.Label>

                          <BForm.Select
                            type='text'
                            name='tag'
                            value={values.tag}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            <option value=''>
                              Select...
                            </option>
                            {Object.values(TAG_OPTIONS).map(({ name, label }) => (
                              <option key={name} value={name}>
                                {label}
                              </option>
                            ))}
                          </BForm.Select>

                          <ErrorMessage
                            component='div'
                            name='tag'
                            className='text-danger'
                          />
                        </Col>
                      </Row>
                    )}

                    <Row className='mt-3'>
                      <Col className='d-grid'>
                        <BForm.Label>Thumbnail</BForm.Label>

                        <BForm.Text>
                          <Trigger message='Only PNG, JPG, JPEG, SVG allowed with size < 1MB'>
                            <input
                              id='file'
                              title=' '
                              name='thumbnail'
                              type='file'
                              onChange={(event) => {
                                setFieldValue(
                                  'thumbnail',
                                  event.currentTarget.files[0]
                                )
                              }}
                            />
                          </Trigger>
                          {values?.thumbnail && (
                            <img
                              alt='not found'
                              width='60px'
                              src={URL.createObjectURL(values.thumbnail)}
                            />
                          )}
                          {!values?.thumbnail && data?.thumbnailUrl && (
                            <img
                              alt='not found'
                              width='60px'
                              src={data.thumbnailUrl}
                            />
                          )}
                        </BForm.Text>

                        <ErrorMessage
                          component='div'
                          name='thumbnail'
                          className='text-danger'
                        />
                      </Col>
                    </Row>
                  </Modal.Body>

                  <div className='mt-4 '>
                    <Modal.Footer className='d-flex justify-content-between align-items-center'>
                      <Button
                        variant='outline-warning'
                        onClick={() => handleClose()}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant='outline-success'
                        onClick={handleSubmit}
                        className='ml-2'
                      >
                        Submit
                        {loading && (
                          <Spinner
                            as='span'
                            animation='border'
                            size='sm'
                            role='status'
                            aria-hidden='true'
                          />
                        )}
                      </Button>
                    </Modal.Footer>
                  </div>
                </Modal>
              </Form>
            )}
          </Formik>)}
    </>
  )
}

export default CreateCasinoProviders
